import React, { ReactNode } from 'react';

import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from 'components/lib/utils';

export interface TooltipProps {
    content: ReactNode;
    children: ReactNode;
    side?: 'top' | 'right' | 'bottom' | 'left';
    align?: 'start' | 'center' | 'end';
    delayDuration?: number;
    className?: string;
}

export const Tooltip: React.FC<TooltipProps> = ({
    content,
    children,
    side = 'top',
    align = 'center',
    delayDuration = 200,
    className
}) => {
    return (
        <TooltipPrimitive.Provider delayDuration={delayDuration}>
            <TooltipPrimitive.Root>
                <TooltipPrimitive.Trigger asChild>
                    {children}
                </TooltipPrimitive.Trigger>
                <TooltipPrimitive.Portal>
                    <TooltipPrimitive.Content
                        side={side}
                        align={align}
                        sideOffset={5}
                        className={cn(
                            'z-50 px-3 py-1.5',
                            'rounded-md',
                            'border border-base-popover',
                            'bg-base-popover',
                            'text-xs text-base-popover-foreground',
                            'shadow-md',
                            'animate-in fade-in-0 zoom-in-95',
                            'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
                            'data-[side=bottom]:slide-in-from-top-2',
                            'data-[side=left]:slide-in-from-right-2',
                            'data-[side=right]:slide-in-from-left-2',
                            'data-[side=top]:slide-in-from-bottom-2',
                            className
                        )}
                        style={{
                            borderRadius: '6px',
                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
                        }}
                    >
                        {content}
                        <TooltipPrimitive.Arrow className="fill-base-popover" />
                    </TooltipPrimitive.Content>
                </TooltipPrimitive.Portal>
            </TooltipPrimitive.Root>
        </TooltipPrimitive.Provider>
    );
};

